import {QueryFunctionContext} from 'react-query';
import request from 'services/axios';

export const getPostWantedDetail = async (ctx: QueryFunctionContext) => {
  const {data}: {data: IPostWantedDetail} = await request.get(
    `/api/v2/market/wanted-post?guid=${ctx.queryKey[1]}`,
  );
  return data;
};
